import { render, staticRenderFns } from "./results-page.vue?vue&type=template&id=1a0ca9e6&scoped=true"
import script from "./results-page.vue?vue&type=script&lang=js"
export * from "./results-page.vue?vue&type=script&lang=js"
import style0 from "./results-page.vue?vue&type=style&index=0&id=1a0ca9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0ca9e6",
  null
  
)

export default component.exports